export interface MisconfigurationsAppWebComponentSchema {
  data: any;
  externalFilters: Array<any>;
}

export enum ColumnKeys {
  COMPANY = 'companyId',
  MISCONFIGURATION_NAME = 'indicatorId',
  RISK_SCORE = 'scoreBreakdown.finalScore',
  AFFECTED_DEVICES = 'affectedDevices',
  OS = 'operatingSystem',
  REGIONS = 'regions',
  MISCONFIGURATION_TYPE = 'subcategory',
  MITIGATION_TYPE = 'mitigation',
  STATUS = 'status',
  STATE = 'state',
  COMPLIANCE = 'compliance',
  AFFECTED_DEVICES_TYPE = 'affectedDevices.type',
  WATCHLIST = 'watchlist',
  SELECT = 'select',
}

// WARNING: Changing the order may break existing Smart Views
export enum Column {
  COMPANY,
  MISCONFIGURATION_NAME,
  RISK_SCORE,
  AFFECTED_DEVICES,
  OS,
  MISCONFIGURATION_TYPE,
  MITIGATION_TYPE,
  STATUS,
  STATE,
  COMPLIANCE,
  AFFECTED_DEVICES_TYPE,
  WATCHLIST,
  SELECT,
  REGIONS,
}
